import type { CallResult } from "../types";

/** Task type created for the next action after a call result */
export const nextTaskType: Record<CallResult, string> = {
  no_answer: "call",
  callback: "callback",
  viewing_scheduled: "viewing",
  not_interested: "none",
  talked: "call",
};

/**
 * Where a call result moves the deal: an answered call takes a new lead to
 * "in progress", a scheduled viewing to "viewing". Never moves backwards.
 */
export const stageAfterCall = (
  stage: string,
  result: CallResult,
  order: string[],
) => {
  const target =
    result === "viewing_scheduled"
      ? "viewing"
      : result === "no_answer"
        ? null
        : "in-progress";
  if (!target) return stage;
  return order.indexOf(target) > order.indexOf(stage) ? target : stage;
};

/** Last 9 digits: the Ukrainian number without country or trunk prefix */
export const phoneKey = (phone: string) => phone.replace(/\D/g, "").slice(-9);
